<template>
  <div class="hello">
    <div id="viewport"></div>
    <button 
    class="close" 
    v-on:click="closeViewer()"
    >
    <span>
      <span></span>
      <span></span>
    </span>
    </button>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

export default {
  name: 'Viewer',
  props: {
    view: String,
    controlSettings: {
      type: Object,
      default: function(){
        return {
          xAxis: {
            min: 0,
            max: 360
          },
          yAxis: {
            min: 70,
            max: 110
          },
          xStart: 0
        }
      }
    }
  },
  data: function(){
    return {
      mesh: {}
    }
  },
  methods: {
    setScene(){
    },
    main() {
      const canvas = document.querySelector('#viewport');
      var renderer = new THREE.WebGLRenderer({ antialias: false });
      renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.outputEncoding = THREE.sRGBEncoding;
      canvas.appendChild(renderer.domElement);

      const fov = 45;
      const aspect = 2;  // the canvas default
      const near = 0.1;
      const far = 100;
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      camera.position.set(0, 0, 0.9);

      const controls = new OrbitControls(camera, canvas);

      controls.enabled = true;
      controls.enablePan = false;
      controls.enableZoom = false;
      controls.rotateSpeed = -0.5;
      controls.minPolarAngle = THREE.Math.degToRad(this.controlSettings.yAxis.min);
      controls.maxPolarAngle = THREE.Math.degToRad(this.controlSettings.yAxis.max);
      controls.minAzimuthAngle = - THREE.Math.degToRad(this.controlSettings.xAxis.min);
      controls.maxAzimuthAngle = THREE.Math.degToRad(this.controlSettings.xAxis.max);
      
      controls.update();

      const scene = new THREE.Scene();
      scene.background = new THREE.Color('black');
      {
        const sphereRadius = 60;
        const sphereWidthDivisions = 24;
        const sphereHeightDivisions = 24;
        const sphereGeo = new THREE.SphereBufferGeometry(sphereRadius, sphereWidthDivisions, sphereHeightDivisions);

        const loader = new THREE.TextureLoader();
        const texture = loader.load( this.getTexture() );
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.magFilter = THREE.NearestFilter;
        const repeats = 1;
        texture.repeat.set(repeats, repeats);
        texture.repeat.x = - 1;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.encoding = THREE.sRGBEncoding;

        const sphereMat = new THREE.MeshBasicMaterial( {
          map: texture,
          side: THREE.BackSide,
          color: 0xffffff,
          // metalness: 0,
          // roughness: 1,
        } );

        this.mesh = new THREE.Mesh(sphereGeo, sphereMat);
        this.mesh.position.set(0,0,0);
        this.mesh.rotation.set(0, THREE.Math.degToRad( this.controlSettings.xStart ) ,0);
        scene.add(this.mesh);
      }
      {
        // const color = 0xFFFFFF;
        // const intensity = 1;
        // const light = new THREE.AmbientLight(color, intensity);
        // scene.add(light);
      }

      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }

      function render() {

        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }

        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.render(scene, camera);

        requestAnimationFrame(render);
      }

      requestAnimationFrame(render);
    },
    closeViewer(){
      this.$parent.currentView = false;
    },
    getTexture(){
      let texture = require('../assets/360-'+ this.$parent.currentView +'.jpg');
      return texture;
    },
    setTexture(){
      let view = this.$parent.currentView;
      let texturefile = require('../assets/360-'+ view +'.jpg');

      var texture = new THREE.TextureLoader().load(texturefile);
      texture.repeat.x = - 1;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.encoding = THREE.sRGBEncoding;
      this.mesh.material.map = texture;
    }
  },
  mounted: function(){
    let self = this;
    this.main();
    self.setTexture();
  },
  watch: {
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#viewport {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 200;
}
button.close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
  width: 5vw;
  height: 5vw;
  min-width: 32px;
  min-height: 32px;
  max-width: 48px;
  max-height: 48px;
  border: 0px;
  border-radius: 50%;
  font-size: 0;
  background: url('../assets/close.png') center center no-repeat;
  background-color: #196390;
  background-size: 80% 80%;
  transition: all 0.25s;
  z-index: 210;
}

button.close:focus {
  outline: none;
  transform: scale(0.7);
}

</style>
